import React, { useState } from "react";
import { useQuery } from "react-query";
import { Link } from "react-router-dom";
import SearchInput from "../../../components/shared/SearchInput";
import Pagination from "../../../components/shared/Pagination";
import api from "../../../utils/api";

export default function SearchDoctors() {
  const [search, setSearch] = useState("");
  const [specialization, setSpecialization] = useState("");
  const [page, setPage] = useState(1);

  const { data, isLoading } = useQuery(
    ["search-doctors", page, search, specialization],
    () =>
      api.get(
        `/patient/search-doctors?page=${page}&search=${search}&specialization=${specialization}`
      ),
    { keepPreviousData: true }
  );

  const { data: specs } = useQuery("specializations", () =>
    api.get("/patient/specializations")
  );

  return (
    <div className="space-y-5">
      {/* Filters */}
      <div className="flex flex-wrap gap-3">
        <SearchInput
          value={search}
          onChange={setSearch}
          placeholder="Search by doctor name…"
          className="w-72"
        />
        <select
          value={specialization}
          onChange={(e) => setSpecialization(e.target.value)}
          className="input-field w-auto"
        >
          <option value="">All Specializations</option>
          {specs?.specializations?.map((s) => (
            <option key={s} value={s}>{s}</option>
          ))}
        </select>
      </div>

      {/* Doctor Cards */}
      {isLoading ? (
        <div className="flex justify-center py-16">
          <div className="w-8 h-8 border-4 border-primary-500 border-t-transparent rounded-full animate-spin" />
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {(data?.data || []).map((doctor) => (
            <div key={doctor.id} className="card hover:shadow-md transition-shadow">
              <div className="flex items-start gap-4">
                <div className="w-14 h-14 rounded-full bg-primary-100 text-primary-700 flex items-center justify-center text-2xl flex-shrink-0">
                  👨‍⚕️
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-display font-semibold text-slate-800 truncate">
                    Dr. {doctor.name}
                  </h3>
                  <p className="text-primary-600 text-sm">{doctor.specialization}</p>
                  <p className="text-slate-500 text-xs mt-1">{doctor.degree}</p>
                  <div className="mt-3 flex items-center justify-between">
                    <span className="text-sm font-semibold text-slate-700">
                      ₹{doctor.fees}
                    </span>
                    <Link
                      to={`/patient/book-appointment/${doctor.id}`}
                      className="btn-primary text-xs px-3 py-1.5"
                    >
                      Book Now
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {!isLoading && (data?.doctors || []).length === 0 && (
        <div className="text-center py-16 text-slate-400">
          No doctors found matching your search.
        </div>
      )}

      <Pagination
        page={page}
        totalPages={data?.totalPages || 1}
        onPageChange={setPage}
      />
    </div>
  );
}
